@if (enrollmentDetails$ | async; as enrollmentDetails) {
  <div class="grid grid-cols-12 gap-4 p-fluid p-form-widget p-form-view-data">
    <div class="col-span-12 md:col-span-6">
      <div class="mnc-form">
        <label>Health Plan:</label>
        <div class="form-value">{{ enrollmentDetails.healthPlan  | emptyPlaceholder }}</div>
        <label>Health/Benefit Plan:</label>
        <div class="form-value">{{ enrollmentDetails.benefitPlan  | emptyPlaceholder }}</div>
        <label>GRS Contract Number & Plan ID:</label>
        <div class="form-value">{{ enrollmentDetails.grsContractNumberPlanID  | emptyPlaceholder }}</div>
        <label>Health Plan Coverage Start Date:</label>
        <div class="form-value">{{ enrollmentDetails.eligibilityEffectiveBeginDate | date: 'MM/dd/yyyy' | emptyPlaceholder }}</div>
        <label>Health Plan Coverage End Date:</label>
        <div class="form-value">{{ enrollmentDetails.eligibilityEffectiveEndDate | date: 'MM/dd/yyyy' | emptyPlaceholder }}</div>
        <label>Member Status:</label>
        <div class="form-value">
          <span>{{ enrollmentDetails.patientStatus ? 'Active' : 'Inactive'  | emptyPlaceholder }}</span>
        </div>
        <label>Authorization Eligibility:</label>
        <div class="form-value">
          <span class="d-inline-flex items-center">
            {{ pacEligibilityMessage }}
            @if (pacErrorMessages.length > 0) {
              <i class="pi pi-info-circle ml-2" pTooltip="{{ pacErrorMessages.join(', &#10;') }}"
                [tooltipStyle]="{ 'white-space': 'pre' }" tooltipPosition="right">
              </i>
            }
          </span>
        </div>
      </div>
    </div>
    <div class="col-span-12 md:col-span-6">
      <div class="mnc-form">
        <label>Member Type:</label>
        <div class="form-value">{{ enrollmentDetails.patientType  | emptyPlaceholder }}</div>
        <label>Member ID: </label>
        <div class="form-value">{{ enrollmentDetails?.displayMemberId || enrollmentDetails.subscriberNumber}}</div>
        @if (showGroupId) {
          <label>Group ID: </label>
          <div class="form-value">{{ groupId }}</div>
        }
        <label>Product Identifier:</label>
        <div class="form-value">{{ enrollmentDetails.productIdentifier  | emptyPlaceholder }}</div>
        <label>Network Identifier:</label>
        @for (networkType of (enrollmentDetails?.networkTypes?.length ? enrollmentDetails.networkTypes  : ['']); track networkType) {
          <div class="form-value">
            <span>
              {{ networkType  | emptyPlaceholder }}
            </span>
          </div>
        }
        <label>Program Assignment:</label>
        <div class="form-value">{{ enrollmentDetails.programAssignment  | emptyPlaceholder }}</div>
        <label>Class Plan Product Code:</label>
        <div class="form-value">{{ enrollmentDetails.benefitPlanName  | emptyPlaceholder }}</div>
        <label>Program Name: </label>
        <div class="form-value">{{ enrollmentDetails.programName  | emptyPlaceholder }}</div>
      </div>
    </div>
  </div>
} @else {
  <div class="flex justify-center">
    <p-progressSpinner></p-progressSpinner>
  </div>
}

